module.exports = __webpack_public_path__ + "static/img/LifeatDito3b.8dbd8ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hr/LifeatDito3b.png
// module id = lvfi
// module chunks = 2